<template>
  <div class="popup-backdrop"></div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api';

const PopupBackdrop = defineComponent({
  name: 'PopupBackdrop',
});
export default PopupBackdrop;
</script>

<style lang="scss" scoped>
@import 'stylesheets/mixins';

.popup-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: $z-index-popup-bg;
  background-color: black;
  opacity: 0.5;
  transition: opacity 0.15s linear;
}
</style>
